<template>
    <div class="px-4 py-8 sm:px-6 md:py-12 lg:px-16">
        <h2 class="text-3xl sm:text-[40px] font-[900] mb-6 capitalize text-left">Upcoming Events</h2>
        <div class="space-y-8">
            <a v-for="(event, index) in eventItems" :key="index" 
               :href="event.linkMedia"
               class="block group cursor-pointer border-b border-gray-200 pb-8 last:pb-0 last:border-b-0">
                
                <div class="flex flex-col sm:flex-row items-start w-full">
                <div class="bg-[#00395a] text-white text-center flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 flex flex-col items-center justify-center mr-0 sm:mr-6 mb-4 sm:mb-0 rounded">
                    <h3 class="text-lg sm:text-xl">{{getDayOfWeek(event.linkDate)}}</h3>
                    <h3 class="font-[900] text-2xl sm:text-3xl -mt-1">{{getDayOfMonth(event.linkDate)}}</h3>
                </div>
                
                <img :src="event.linkImage" class="block sm:hidden w-full sm:w-48 md:w-64 h-40 sm:h-auto object-cover rounded-md mr-0 sm:mr-6 mb-4 sm:mb-0 flex-shrink-0">

                 <div class="flex flex-col justify-start text-left flex-grow">
                    <p class="text-black text-base mb-2">{{ getFormattedDate(event.linkDate) }}</p>
                    <h3 class="text-[#00395a] mr-auto group-hover:underline font-[900] text-xl sm:text-2xl mb-2">{{ event.linkName }}</h3>
                    <p class="text-gray-700 text-base font-[500]">{{ event.linkDescription }}</p>
                </div> 
                <img :src="event.linkImage" class="ml-4 hidden sm:block w-full sm:w-48 md:w-64 h-40 sm:h-auto object-cover rounded-md mr-0 sm:mr-6 mb-4 sm:mb-0 flex-shrink-0">   
                </div>
             </a>
             </div>
     </div>
</template>
<script>
export default {
  name: 'HomeEvents',
  props: {
    eventItems: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
    };
  },
  methods: {
    getFormattedDate(dateString) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString('en-US', options);
    },

   getDayOfWeek(dateString) {
      const date = new Date(dateString);
      const options = { weekday: 'short' };
      return date.toLocaleDateString('en-US', options);
    },

    getDayOfMonth(dateString) {
      const date = new Date(dateString);
      return date.getDate();
    },

    // Methods can be added here if needed
  }
};
</script>